import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimWorkOrderVersionObjectDataFilterInput } from 'gql/graphql';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimWorkOrderVersionObjectsGql } from '../../workOrderVersionQueries';

const requestId = 'bimWorkOrderVersionObjects';

export const useBimWorkOrderVersionSelectionList = (workOrderVersionId?: number, withEffect = true) => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            workOrderVersionId,
        }),
        [workOrderVersionId],
    );

    const [
        bimWorkOrderObjectSelectionListData,
        bimWorkOrderObjectSelectionListStatus,
        bimWorkOrderObjectSelectionListError,
        bimWorkOrderObjectSelectionListRequest,
    ] = useRequest({
        requestId,
        query: bimWorkOrderVersionObjectsGql,
        withEffect: false,
        variables,
    });

    const [bimWorkOrderObjectSelectionListReset] = useResetStoreData({ requestId });

    const bimWorkOrderObjectSelectionListMakeRequest = useCallback(
        (wOrderId: number, constructionTypeId?: number) => {
            if (!constructionTypeId) {
                return;
            }

            const where: BimWorkOrderVersionObjectDataFilterInput | undefined = constructionTypeId
                ? {
                      constructionType: { id: { eq: constructionTypeId } },
                  }
                : undefined;

            bimWorkOrderObjectSelectionListReset(undefined);
            dispatch(bimWorkOrderObjectSelectionListRequest({ workOrderVersionId: wOrderId, where }));
        },
        [bimWorkOrderObjectSelectionListRequest, bimWorkOrderObjectSelectionListReset, dispatch],
    );

    return {
        bimWorkOrderObjectSelectionListReset,
        bimWorkOrderObjectSelectionListData,
        bimWorkOrderObjectSelectionListStatus,
        bimWorkOrderObjectSelectionListError,
        bimWorkOrderObjectSelectionListRequest,
        bimWorkOrderObjectSelectionListMakeRequest,
    };
};
